import * as assign from 'object.assign'
import Promise from 'promise-polyfill'

import 'ie-string-startswith-polyfill'
import 'polyfill-array-includes'

if (!Object.assign) {
  Object.assign = assign
}

if (!window.Promise) {
  window.Promise = Promise
}

export { assign, Promise }
